import { Injectable } from '@angular/core';
import { catchError, map, Observable, of, Subject } from 'rxjs';
import { environment } from '../environment/environment';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { restEndPoints } from './app.constants';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  baseUrl = environment.apiHost;
  private sessionExpiredSubject = new Subject<void>();
  public selectedOrg = new Subject<any>();


  // Observable to listen for session expiration
  sessionExpired$ = this.sessionExpiredSubject.asObservable();
  users  =[]
  constructor(private httpClient:HttpClient, private _snackBar: MatSnackBar) { } 

  authLogin(email: string , password: string): Observable<string | null> {
    return this.httpClient.post<any>(`${this.baseUrl}api/Auth/Login`, { email, password }).pipe(
      map((response: any) => {
        // Check if response contains authToken and return it
        if (response && response.value) {
          return response.value.authToken;  // Return the authToken
        }
        return null;  // Return null if authToken is not found
      }),
      catchError((error) => {
        
         // Show the error message in a snackbar
         this._snackBar.open('Login failed. Please check your credentials and try again.', 'Close', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });

        // Return null in case of an error
        return of(null);
      })
    );
  }

   // Method to trigger the session expired event
   emitSessionExpired() {
    this.sessionExpiredSubject.next();
  }

   // Show a snackbar when the session has expired
   showSessionExpiredMessage(): void {
    this._snackBar.open('Session expired. Please log in again.', 'Close', {
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
    localStorage.clear();
  }

  setToken(token: string) {
    localStorage.setItem('authToken', token); // Store token in localStorage
  }

  getToken(): string | null {
    return localStorage.getItem('authToken'); // Retrieve token
  }

  logout(): void {
    localStorage.clear(); 
  }

  resetPassword(email: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}${restEndPoints.authentication.resetPassword}?Email=${email}`, {});
  } 

  auth(email: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}${restEndPoints.authentication.auth}?userName=${email}`, {});
  } 

  validateLogin(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}${restEndPoints.authentication.validateLogin}`, data);
  }

  changePassword(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}${restEndPoints.authentication.changePassword}`, data);
  }

  getDashboardScreenByOrg(): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}${restEndPoints.authentication.screenByOrg}`);

  }
}